'use client';
var classes = {"root":"m-ddec01c0","icon":"m-dde7bd57","cite":"m-dde51a35"};

export { classes as default };
//# sourceMappingURL=Blockquote.module.css.mjs.map
